module.exports = __webpack_public_path__ + "img/5d52665.v2.17.5.png";